import { n as normalizeComponent } from './normalize-component.js';

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script = {
  props: {
    beacons: {
      required: true
    }
  },
  data: function data() {
    return {
      number: '',
      editNumber: '',
      validChars: [],
      ready: false,
      hint: '',
      hintTimeout: null
    };
  },
  mounted: function mounted() {
    this.updateValidChars();
  },
  computed: {
    selectedPage: function selectedPage() {
      return this.number ? this.beacons[this.number] : null;
    },
    pageTitle: function pageTitle() {
      if (this.beacons[this.number]) {
        var title = this.beacons[this.number].title.replace(new RegExp('^' + this.number + ' '), '');
        return title;
      }

      return '';
    }
  },
  methods: {
    getValidChars: function getValidChars() {
      var position = this.number.length;
      var validChars = {};

      for (var beacon in this.beacons) {
        if (beacon.length >= position && beacon.substr(0, position) === this.number && beacon.charAt(position) > '') {
          validChars[beacon.charAt(position)] = 0;
        }
      } // console.log('GetValidChars:', Object.keys(validChars))


      return Object.keys(validChars);
    },
    updateValidChars: function updateValidChars() {
      this.validChars = this.getValidChars();
    },
    onNumClick: function onNumClick(num) {
      this.number = this.number + num;
    },
    onDelClick: function onDelClick() {
      if (this.number.length > 0) {
        this.number = this.number.slice(0, -1);
      }
    },
    isNumEnabled: function isNumEnabled(num) {
      return this.validChars.indexOf(num) >= 0;
    },
    onSelectPage: function onSelectPage(e) {
      if (this.selectedPage) {
        this.$router.push('/page/' + this.selectedPage.pageID);
      } else {
        this.setHint(this.$t('global.srNumberIncomplete') + ' ' + this.$t('global.srValidDigits') + ' ' + this.validChars.join(', ') + '.');
        if (window.navigator.vibrate) window.navigator.vibrate(600);
      }

      if (e) e.preventDefault();
      return false;
    },
    setHint: function setHint(hint) {
      var _this = this;

      if (this.hintTimeout) clearTimeout(this.hintTimeout);
      this.hintTimeout = setTimeout(function () {
        _this.hint = hint;
      }, 300);
    },
    onChange: function onChange(e) {
      this.hint = '';
      var $input = e.target;
      var val = $input.value;
      var regex = new RegExp(/^(?:[0-9]|[a-z])*$/, 'i');
      var valid = regex.test(val) && (!e.data || regex.test(e.data));

      if (!e.data && valid && val.length < this.number.length) {
        // Letztes Zeichen geloescht
        this.number = val;
      } else if (!valid) {
        // Ungueltiges Zeichen eingegeben
        this.editNumber = $input.value = this.number;
        this.setHint(this.$t('global.srWrongCharacter') + ' ' + this.$t('global.srValidDigits') + ' ' + this.validChars.join(', ') + '.');
      } else {
        // Gueltige Eingabe
        this.number = val;
      }
    }
  },
  watch: {
    number: function number(val) {
      var validChars = this.getValidChars();

      if (val.length > 0) {
        if (validChars.length || Object.keys(this.beacons).includes(val)) {
          this.validChars = validChars;

          if (validChars.length === 0) {
            this.setHint(this.$t('global.srConfirmNumber').replace('<pageTitle>', this.pageTitle));
          }
        } else {
          val = val.slice(0, -1);
          this.number = val;
          this.editNumber = val;
          this.setHint(this.$t('global.srWrongDigit') + ' ' + this.$t('global.srValidDigits') + ' ' + this.validChars.join(', ') + '.');
        }
      } else {
        this.validChars = validChars;
      } // console.log('watch number:', this.number, ', validChars:', this.validChars.join(','))

    },
    beacons: function beacons(val) {
      this.ready = !!val && Object.keys(val).length > 0;
      this.updateValidChars();
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "c-numpad" }, [
    _c("div", { staticClass: "c-numpad__display" }, [
      _vm.number
        ? _c(
            "span",
            {
              staticClass: "c-numpad__number",
              attrs: { "aria-hidden": "true" }
            },
            [_vm._v(_vm._s(_vm.number))]
          )
        : _vm._e(),
      _vm.number
        ? _c(
            "span",
            {
              staticClass: "c-numpad__title",
              attrs: { "aria-hidden": "true" }
            },
            [_vm._v(_vm._s(_vm.pageTitle))]
          )
        : _c(
            "span",
            {
              staticClass: "c-numpad__title",
              attrs: { "aria-hidden": "true" }
            },
            [_vm._v(_vm._s(_vm.$t("global.srEnterNumber")))]
          ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "c-numpad__sr sr-only",
          attrs: { "aria-live": "polite", role: "status" }
        },
        [
          _c("form", { on: { submit: _vm.onSelectPage } }, [
            (this.$xp.settings.mergedSettings.navigation.numpadInputExtraButtons
              .length
              ? "text"
              : "number") === "checkbox"
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.editNumber,
                      expression: "editNumber"
                    }
                  ],
                  attrs: {
                    id: "numpad__enterNumber",
                    "aria-label": _vm.$t("global.srNumber"),
                    type: "checkbox"
                  },
                  domProps: {
                    checked: Array.isArray(_vm.editNumber)
                      ? _vm._i(_vm.editNumber, null) > -1
                      : _vm.editNumber
                  },
                  on: {
                    input: _vm.onChange,
                    change: function($event) {
                      var $$a = _vm.editNumber,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false;
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v);
                        if ($$el.checked) {
                          $$i < 0 && (_vm.editNumber = $$a.concat([$$v]));
                        } else {
                          $$i > -1 &&
                            (_vm.editNumber = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)));
                        }
                      } else {
                        _vm.editNumber = $$c;
                      }
                    }
                  }
                })
              : (this.$xp.settings.mergedSettings.navigation
                  .numpadInputExtraButtons.length
                  ? "text"
                  : "number") === "radio"
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.editNumber,
                      expression: "editNumber"
                    }
                  ],
                  attrs: {
                    id: "numpad__enterNumber",
                    "aria-label": _vm.$t("global.srNumber"),
                    type: "radio"
                  },
                  domProps: { checked: _vm._q(_vm.editNumber, null) },
                  on: {
                    input: _vm.onChange,
                    change: function($event) {
                      _vm.editNumber = null;
                    }
                  }
                })
              : _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.editNumber,
                      expression: "editNumber"
                    }
                  ],
                  attrs: {
                    id: "numpad__enterNumber",
                    "aria-label": _vm.$t("global.srNumber"),
                    type: this.$xp.settings.mergedSettings.navigation
                      .numpadInputExtraButtons.length
                      ? "text"
                      : "number"
                  },
                  domProps: { value: _vm.editNumber },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.editNumber = $event.target.value;
                      },
                      _vm.onChange
                    ]
                  }
                }),
            _vm._v(" "),
            _vm.hint
              ? _c("div", { attrs: { role: "alert" } }, [
                  _vm._v("\n            " + _vm._s(_vm.hint) + "\n          ")
                ])
              : _vm._e()
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "c-numpad__pad", attrs: { "aria-hidden": "true" } },
      [
        _c(
          "button",
          {
            staticClass: "c-numpad__button link",
            attrs: { id: "c-numpad__1", disabled: !_vm.isNumEnabled("1") },
            on: {
              click: function($event) {
                return _vm.onNumClick("1")
              }
            }
          },
          [_vm._v("1")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "c-numpad__button link",
            attrs: { id: "c-numpad__2", disabled: !_vm.isNumEnabled("2") },
            on: {
              click: function($event) {
                return _vm.onNumClick("2")
              }
            }
          },
          [_vm._v("2")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "c-numpad__button link",
            attrs: { id: "c-numpad__3", disabled: !_vm.isNumEnabled("3") },
            on: {
              click: function($event) {
                return _vm.onNumClick("3")
              }
            }
          },
          [_vm._v("3")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "c-numpad__button link",
            attrs: { id: "c-numpad__4", disabled: !_vm.isNumEnabled("4") },
            on: {
              click: function($event) {
                return _vm.onNumClick("4")
              }
            }
          },
          [_vm._v("4")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "c-numpad__button link",
            attrs: { id: "c-numpad__5", disabled: !_vm.isNumEnabled("5") },
            on: {
              click: function($event) {
                return _vm.onNumClick("5")
              }
            }
          },
          [_vm._v("5")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "c-numpad__button link",
            attrs: { id: "c-numpad__6", disabled: !_vm.isNumEnabled("6") },
            on: {
              click: function($event) {
                return _vm.onNumClick("6")
              }
            }
          },
          [_vm._v("6")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "c-numpad__button link",
            attrs: { id: "c-numpad__7", disabled: !_vm.isNumEnabled("7") },
            on: {
              click: function($event) {
                return _vm.onNumClick("7")
              }
            }
          },
          [_vm._v("7")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "c-numpad__button link",
            attrs: { id: "c-numpad__8", disabled: !_vm.isNumEnabled("8") },
            on: {
              click: function($event) {
                return _vm.onNumClick("8")
              }
            }
          },
          [_vm._v("8")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "c-numpad__button link",
            attrs: { id: "c-numpad__9", disabled: !_vm.isNumEnabled("9") },
            on: {
              click: function($event) {
                return _vm.onNumClick("9")
              }
            }
          },
          [_vm._v("9")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "c-numpad__button link",
            attrs: { id: "c-numpad__0", disabled: !_vm.isNumEnabled("0") },
            on: {
              click: function($event) {
                return _vm.onNumClick("0")
              }
            }
          },
          [_vm._v("0")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "c-numpad__button link",
            attrs: {
              id: "c-numpad__back",
              disabled: this.number.length === 0,
              title: _vm.$t("global.numPadBack"),
              "area-label": "$t('global.numPadBack')"
            },
            on: {
              click: function($event) {
                return _vm.onDelClick()
              }
            }
          },
          [
            _c("span", {
              staticClass: "xp xp--large xp-backspace",
              attrs: { "aria-hidden": "true" }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            ref: "enter",
            staticClass: "c-numpad__button link",
            attrs: {
              id: "c-numpad__enter",
              disabled: !_vm.selectedPage,
              title: _vm.$t("global.numPadEnter"),
              "area-label": "$t('global.numPadEnter')"
            },
            on: { click: _vm.onSelectPage }
          },
          [
            _c("span", {
              staticClass: "xp xp--large xp-check",
              attrs: { "aria-hidden": "true" }
            })
          ]
        ),
        _vm._v(" "),
        _vm._l(
          this.$xp.settings.mergedSettings.navigation.numpadInputExtraButtons,
          function(char, index) {
            return _c(
              "button",
              {
                key: index,
                staticClass: "c-numpad__button link",
                attrs: { disabled: !_vm.isNumEnabled(char) },
                on: {
                  click: function($event) {
                    return _vm.onNumClick(char)
                  }
                }
              },
              [_vm._v(_vm._s(char))]
            )
          }
        )
      ],
      2
    )
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
//# sourceMappingURL=NumpadInput.js.map
